import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  taxes: [],
  loading: false,
  error: null,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 10,
    isLastPage: false,
    isFirstPage: true,
  },
};

const taxListSlice = createSlice({
  name: "TaxList",
  initialState,
  reducers: {
    fetchTaxesStart(state) {
      state.loading = false;
      state.error = null;
    },
    fetchTaxesSuccess(state, action) {
      state.taxes = action.payload.taxes;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = null;
    },
    fetchTaxesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    addTaxStart(state) {
      state.loading = true;
      state.error = null;
    },
    addTaxSuccess(state, action) {
      state.loading = false;
      state.taxes.unshift(action.payload);
      state.error = null;
    },
    addTaxesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    deleteTaxStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteTaxSuccess(state, action) {
      state.loading = false;
      state.taxes = state.taxes.filter((tax) => tax.id !== action.payload);
    },
    deleteTaxFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateTaxStart(state) {
      state.loading = false;
      state.error = null;
    },
    updateTaxSuccess(state, action) {
      state.loading = false;
      const updatedTax = action.payload;
      const index = state.taxes.findIndex((tax) => tax.id === updatedTax.id);
      if (index !== -1) {
        state.taxes[index] = updatedTax;
      }
    },
    updateTaxFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    updateTaxStatusStart(state) {
      state.loading = false;
      state.error = null;
    },
    updateTaxStatusSuccess(state, action) {
      state.loading = false;
      const updatedTaxStatus = action.payload;
      const index = state.taxes.findIndex(
        (tax) => tax.id === updatedTaxStatus.id
      );
      if (index !== -1) {
        state.taxes[index] = updatedTaxStatus;
      }
    },
    updateTaxStatusFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    resetTaxesList(state) {
      state.taxes = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchTaxesStart,
  fetchTaxesSuccess,
  fetchTaxesFailure,
  resetTaxesList,
  addTaxesFailure,
  addTaxSuccess,
  addTaxStart,
  updateTaxStatusStart,
  updateTaxStatusSuccess,
  updateTaxStatusFailure,
  deleteTaxStart,
  deleteTaxSuccess,
  deleteTaxFailure,
  updateTaxStart,
  updateTaxSuccess,
  updateTaxFailure,
} = taxListSlice.actions;

export default taxListSlice.reducer;
